import React, { Component } from "react";
import { Form, FormGroup, Col, Button, Row, Popover, PopoverHeader, PopoverBody, Alert } from "reactstrap";
import {kpisMapping, chartStep} from '../../../../utils/constants';
import {getStatesByCountryCode} from '../../../../utils/states';
import {getCountries} from '../../../../utils/countries';
import {getAgreegateKpisData, getBenchmarkData, filterBenchmarkByState} from '../../../../utils/filterKpisData';
import ChartPreview from '../ChartPreview/ChartPreview';
import Tooltip from '../../../../components/UI/TooltipIcon/TooptipIcon';
import ErrorMessage from '../../../../components/Message/ErrorMessage/ErrorMessage';
import InfoMessage from '../../../../components/Message/InfoMessage/InfoMessage';
import DatePicker from "react-datepicker";
import moment from "moment";
import Toggle from "react-toggle";
import pick from 'lodash/pick';
import Select from "react-select";
import 'rc-checkbox/assets/index.css';
import "react-datepicker/dist/react-datepicker.css";
import "react-toggle/style.css";
import "react-select/dist/react-select.css";
import "../Component.css";

export default class Benchmark extends Component {
    constructor(props) {
        super(props);
        this.state = {
            startDate: (this.props.chartDetails.startDate!=='' && this.props.chartDetails.startDate!==null) ? moment.utc(this.props.chartDetails.startDate) : null,
            endDate: (this.props.chartDetails.endDate!=='' && this.props.chartDetails.endDate!==null) ? moment(this.props.chartDetails.endDate) : null,
            useLatestDataAvailable: this.props.chartDetails.useLatestDataAvailable,
            benchmarkPopoverOpen: false,
            dataAvailablePopoverOpen: false,
            kpiAgreegateData: this.props.chartDetails.kpiAgreegateData,
            kpiBenchmarkData: this.props.chartDetails.kpiBenchmarkData?  this.props.chartDetails.kpiBenchmarkData:[],
            benchmarkError: false,
            error: false,
            isPreview:false,
            previewOrContinue:false,
            errorMessage: "",
            kpiRecords: this.props.chartDetails.kpiRecords,
            kpiRecord: null,
            emptyStateImage:null,
            kpiType: this.props.chartDetails.kpiType,
            kpiData: this.props.chartDetails.kpiData,
            benchmarkData: this.props.chartDetails.benchmarkData,
            selectedBenchmarkData: this.props.chartDetails.selectedBenchmarkData,
            benchmarkLocation: this.props.chartDetails.benchmarkLocation,
            showPreviewBtn: false,
            countriesOptions: getCountries(),
        };
    }

    componentWillMount() {
        let {kpiAgreegateData,kpiBenchmarkData,startDate, endDate, useLatestDataAvailable} = this.props.chartDetails; 
        let kpiRecords = this.props.chartDetails.kpiRecords.filter(kpi => kpi.selected);
        let kpiRecord = null;
        if(kpiRecords.length>0) {
          kpiRecord = kpiRecords[0]
        } 
        // console.log(kpiBenchmarkData)
        let selectedBenchmarkData = kpiBenchmarkData;
        let benchmarkData = [];
        let {country, state} = this.props.chartDetails.benchmarkLocation;
        let benchmarkLocation = this.props.chartDetails.benchmarkLocation;
        if(country===null) {
          if(kpiRecord.occupation!==null) {
            //  console.log("occupation here! c/omponentWillMount")
            benchmarkLocation = { country:{ name: 'United States', code: 'US' }, state: null};
            selectedBenchmarkData = filterBenchmarkByState(kpiBenchmarkData,null);
          } else if (kpiRecord.occupation===null && kpiRecord.seniority!==null){
            //  all --> null
            selectedBenchmarkData = filterBenchmarkByState(kpiBenchmarkData,'ALL');
            benchmarkLocation = { country:{ name: 'United States', code: 'US' }, state: { id: 'ALL', name: 'All' }};
            // console.log('sel ', selectedBenchmarkData);
          } else if (this.props.chartDetails.benchmarkData && this.props.chartDetails.benchmarkData.location && this.props.chartDetails.benchmarkData.location.key) {
            let {key, name} =  this.props.chartDetails.benchmarkData.location;
            benchmarkLocation = { country:{ name: 'United States', code: 'US' }, state: { id: key, name: name }};
            selectedBenchmarkData = filterBenchmarkByState(kpiBenchmarkData,name);
          } else {
            benchmarkLocation = { country:{ name: 'United States', code: 'US' }, state: { id: 'ALL', name: 'All' }};
            selectedBenchmarkData = filterBenchmarkByState(kpiBenchmarkData,'ALL');
          }
          // console.log(selectedBenchmarkData, kpiBenchmarkData)
            benchmarkData = getBenchmarkData({selectedBenchmark: selectedBenchmarkData, kpiAgreegateData}, false, {startDate, endDate, useLatestDataAvailable});
          this.setState({kpiRecord, benchmarkLocation, selectedBenchmarkData, benchmarkData}); 
        } else {
          this.setState({kpiRecord, benchmarkLocation});  
        }
    }
    componentDidMount() {
        window.scrollTo(0, 0);
        let{kpiBenchmarkData,benchmarkData}=this.state
        this.setSelectedBenchmark(this.props, {}, {});
        // kpiBenchmarkData
        // let benchmark = this.props.chartDetails.kpiBenchmarkData
        let detailsState = pick({...this.state}, ['kpiData', 'useLatestDataAvailable', 'selectedBenchmarkData']);
          // console.log('detials---', detailsState)
        let filteredKpiData =[]
        filteredKpiData = detailsState && detailsState.kpiData && detailsState.kpiData.length >0? detailsState.kpiData.filter(kpi => kpi.score): this.props.goBackToPreviousStep()

        // let filteredKpiData = detailsState.kpiData.filter(kpi => kpi.score);
        let benchmarkError = false;


        if (filteredKpiData && filteredKpiData.length === 0 && (detailsState.selectedBenchmarkData === null || detailsState.selectedBenchmarkData.length === 0)) {
          benchmarkError = true;
         } else {
          if(detailsState.selectedBenchmarkData && detailsState.selectedBenchmarkData.length > 0) {
            let benchmarksWithTrends = detailsState.selectedBenchmarkData[0].filter(benchmark => benchmark.trend.length > 0);
            if (benchmarksWithTrends.length === 0 && filteredKpiData.length === 0 ) {
               benchmarkError = true;
            }
          } 
         }

      
        //  console.log('this - ', this.state)

        if(this.state.kpiBenchmarkData.length ===0 && filteredKpiData.length!==0){
          window.scrollTo(0, 0);
          this.setState({ isPreview:true, error: true, errorMessage: 'There is currently no benchmark data available for the KPI you selected. <br> We are working hard to build anonymized aggregate benchmarks for all KPIs as our users add their data. For now, you can select other KPIs to find out if their benchmarks are available.' });
        } else if (filteredKpiData && filteredKpiData.length===0 && this.state.kpiBenchmarkData.length===0){
          window.scrollTo(0, 0);
          this.setState({error: true, emptyStateImage: true, errorMessage: "To continue, please select KPIs and/or dates for which there's data available."})
        } else if (this.state.kpiBenchmarkData.length!==0 && filteredKpiData && filteredKpiData.length===0) {
          window.scrollTo(0, 0);
          this.setState({error: false, errorMessage: null })
        }

  
        // console.log(benchmarkData)

  
       
      }

      // componentDidUpdate

    componentWillReceiveProps(nextProps) {
      // console.log("wiill receive props")
      let {kpiAgreegateData, kpiBenchmarkData} = {...nextProps.chartDetails};
      let {kpiType, kpiRecords, startDate, endDate, useLatestDataAvailable} = this.state;
      let kpiData = {};
      let stateChanges = {};
      if (kpiAgreegateData && kpiAgreegateData.length > 0) {
        let formattedKpiData = getAgreegateKpisData({ kpiRecords, kpiAgreegateData, kpiType, startDate, endDate, useLatestDataAvailable, kpiBenchmarkData});
        kpiData = {kpiData: formattedKpiData};
      } else {
        kpiData =  {kpiData: []};
      }
     
      if (kpiAgreegateData.length > 0 || kpiBenchmarkData.length > 0) {
         stateChanges = { kpiAgreegateData, kpiBenchmarkData, benchmarkError: kpiBenchmarkData && kpiBenchmarkData.length === 0 };
         this.setSelectedBenchmark(nextProps, kpiData, stateChanges);
        }
    }

  setSelectedBenchmark = (props, kpiData, stateChanges) => {
    let {kpiType, kpiRecords, kpiBenchmarkData, startDate, endDate, useLatestDataAvailable, selectedBenchmarkData, benchmarkData} = this.state;
    let benchmarkLocation = {country: null, state: null};
    let {country, state} = this.state.benchmarkLocation;
    let { kpiAgreegateData} = props.chartDetails;
    let isPreview;
    // let kpiBenchmarkData = props.chartDetails.selectedBenchmarkData
    // console.log( country, this.state.benchmarkLocation, props.chartDetails)
    if (country === null && state === null && props.chartDetails.benchmarkData && kpiAgreegateData && kpiAgreegateData.length>0 && kpiBenchmarkData && kpiBenchmarkData.length>0) {
      let { location } = props.chartDetails.benchmarkData;
      benchmarkLocation = { country: { name: 'United States', code: 'US' }, state: { id: location.key, name: location.name } };
      selectedBenchmarkData = filterBenchmarkByState(kpiBenchmarkData,benchmarkLocation.state.name);
      benchmarkData = getBenchmarkData({selectedBenchmark: selectedBenchmarkData, kpiAgreegateData}, false, {startDate, endDate, useLatestDataAvailable});
      // console.log(benchmarkData,'---selected --', selectedBenchmarkData)
    } else {
      benchmarkLocation = this.state.benchmarkLocation;
      // console.log(benchmarkLocation)
      // console.log(benchmarkLocation)
      if(kpiBenchmarkData && kpiBenchmarkData[0] && kpiBenchmarkData[0][0] && (kpiBenchmarkData[0][0].location || kpiBenchmarkData[0][0].kpi==="REP-1" )){
        if(benchmarkLocation.state===null){
          benchmarkLocation = { country: { name: 'United States', code: 'US' }, state: { id: 'ALL', name: 'All' } };
        }
        selectedBenchmarkData = filterBenchmarkByState(kpiBenchmarkData, benchmarkLocation.state.name);
      } else{
        selectedBenchmarkData = kpiBenchmarkData
      }
      // console.log(selectedBenchmarkData)
      if( (selectedBenchmarkData[0] && selectedBenchmarkData[0].length===0) || kpiBenchmarkData && kpiBenchmarkData.length===0 ){
        isPreview=true
      }  
      benchmarkData = getBenchmarkData({selectedBenchmark: selectedBenchmarkData, kpiAgreegateData}, false, {startDate, endDate, useLatestDataAvailable});
    }
    this.setState({ ...kpiData, ...stateChanges, benchmarkLocation, benchmarkData, isPreview});
  }

   handleStartDateChange = date => {
    let {endDate, useLatestDataAvailable} = this.state;
        if (endDate !== null && date > endDate) {
            this.setState({
                startDate: endDate,
                previewOrContinue:true
            });
            this.getAgreegateKPIRecordData(endDate,endDate,useLatestDataAvailable);
        } else {
            this.setState({
                startDate: date,
                previewOrContinue:true,
            });
            this.getAgreegateKPIRecordData(date,endDate,useLatestDataAvailable);
        }
    };

    handleEndDateChange = date => {
      let {startDate, useLatestDataAvailable} = this.state;
        if (startDate != null && date < startDate) {
            this.setState({
                endDate: startDate,
                error: false,
                previewOrContinue:true
            });
            this.getAgreegateKPIRecordData(startDate,startDate,useLatestDataAvailable);
        } else {
            this.setState({
                endDate: date,
                error: false,
                previewOrContinue:true
            });
            this.getAgreegateKPIRecordData(startDate,date,useLatestDataAvailable);
        }
        
    };

    getAgreegateKPIRecordData = (startDate, endDate, useLatestDataAvailable) => {
      let {kpiRecord, kpiType} = {...this.state};
      if(kpiRecord.selected) {
        this.props.getKpiData({selectedKPIRecords: [kpiRecord],kpiType,startDate,endDate,useLatestDataAvailable});
      } 
    }

    handleUseLatestDateChange = () => {
        let {startDate, useLatestDataAvailable} = this.state;
        this.setState({ previewOrContinue:true,useLatestDataAvailable: !this.state.useLatestDataAvailable, endDate: null, error: false });
        this.getAgreegateKPIRecordData(startDate,null,!useLatestDataAvailable);
      }
      // Toggle popover
    toggleBenchmarkPopover = () => {
        this.setState({
            benchmarkPopoverOpen: !this.state.benchmarkPopoverOpen,
            dataAvailablePopoverOpen: false
        });
    }

    toggleLatestDataAvailablePopover = () => {
        this.setState({
            dataAvailablePopoverOpen: !this.state.dataAvailablePopoverOpen,
            benchmarkPopoverOpen: false
        });
    }
  
    handleCountrySelection = (country, index) => {
      let {benchmarkLocation, benchmarkData, selectedBenchmarkData, startDate, endDate, useLatestDataAvailable, kpiRecord} = {...this.state};
      let {kpiBenchmarkData, kpiAgreegateData} = this.props.chartDetails;
      let {state} = benchmarkLocation;
      if(country!==null && state!==null && country.code === 'US'){
        benchmarkLocation = {country, state};
      } else {
        benchmarkLocation = {country, state: null};
        if(country=== null){
          benchmarkData = null;
          selectedBenchmarkData = null;
        } else {
          if(country.code === 'US' && kpiRecord.occupation===null) {
            benchmarkLocation = {country, state: {id: 'ALL', name: 'All'}};
          } else {
            benchmarkLocation = {country, state: null};
          }
        }
      }
      let benchmarkState = benchmarkLocation.state !== null ? benchmarkLocation.state.name : null; 
      if(benchmarkState!==null || (country!==null && kpiRecord.occupation!==null)) {
        selectedBenchmarkData = filterBenchmarkByState(kpiBenchmarkData,benchmarkState);
        benchmarkData = getBenchmarkData({selectedBenchmark: selectedBenchmarkData, kpiAgreegateData}, false, {startDate, endDate, useLatestDataAvailable});
      }
      this.setState({benchmarkLocation, benchmarkData, selectedBenchmarkData});
    }
  
    handleStatesSelection = (selectedStates) => {
      // console.log('state --', selectedStates)
      let {benchmarkLocation, startDate, endDate, useLatestDataAvailable, benchmarkData, kpiRecord} = {...this.state};
      let selectedBenchmarkData = null;
      let {kpiBenchmarkData, kpiAgreegateData} = this.props.chartDetails;
      let {country} = benchmarkLocation;
      if(selectedStates!==null) {
        benchmarkLocation = {country, state: selectedStates}; 
        selectedBenchmarkData = filterBenchmarkByState(kpiBenchmarkData,selectedStates.name);
        benchmarkData = getBenchmarkData({selectedBenchmark: selectedBenchmarkData, kpiAgreegateData}, false, {startDate, endDate, useLatestDataAvailable});
      } else {
        benchmarkLocation = {country, state: null};
        selectedBenchmarkData = null;
        benchmarkData = null;
        if (kpiRecord.occupation !== null) {
          selectedBenchmarkData = filterBenchmarkByState(kpiBenchmarkData, null);
          benchmarkData = getBenchmarkData({ selectedBenchmark: selectedBenchmarkData, kpiAgreegateData }, false, { startDate, endDate, useLatestDataAvailable });
        }
      }
      
      this.setState({benchmarkLocation, selectedBenchmarkData, benchmarkData});
    }

    handlePreviewChart = () => {
        let {kpiRecord,kpiType,startDate,endDate,useLatestDataAvailable, kpiRecords} = {...this.state};
        if(startDate!==null) {
          startDate = startDate.format('YYYY-MM-DD') + 'T00:00:00.000Z'; 
        }
        if(endDate!==null) {
          endDate = endDate.format('YYYY-MM-DD') + 'T23:59:59.000Z'; 
        }
        if(kpiRecord!==null && kpiRecord.selected) {
            this.props.getKpiData({selectedKPIRecords: [kpiRecord],kpiType,startDate,endDate,useLatestDataAvailable});
        } else {
          this.props.getKpiData({selectedKPIRecords: kpiRecords,kpiType,startDate,endDate,useLatestDataAvailable});
        }
        this.setState({error: false});
    } 

    goToPreviousStep = () => {
      // console.log(this.state)
      let detailsState = pick({...this.state}, ['startDate', 'endDate', 'kpiRecord', 'kpiType', 'kpiData' ,'kpiRecords', 'selectedBenchmark','useLatestDataAvailable', 'selectedBenchmarkData', 'benchmarkData', 'benchmarkLocation']);
      if (detailsState.startDate && detailsState.startDate !== "" && detailsState.startDate !== null) {
        detailsState.startDate = detailsState.startDate.format('YYYY-MM-DD') + 'T00:00:00.000Z'; 
      } else {
        window.scrollTo(0, 0);
        this.setState({ error: true, errorMessage: 'Please select start date.' });
        return;
      }

      // detailsState.selectedBenchmark = detailsState.selectedBenchmarkData

      if (detailsState.endDate && detailsState.endDate !== "" && detailsState.endDate!==null) {
        detailsState.endDate = detailsState.endDate.format('YYYY-MM-DD') + 'T23:59:59.000Z';
      } else {
        detailsState.endDate = null;
      }
      this.props.onCompleted({...detailsState});
        this.props.goBackToPreviousStep(this.props.emptyStateImage);
    };

    // Validate Benchmark Details
    validateBenchmarkDetails = () => {
        let detailsState = pick({...this.state}, ['startDate', 'endDate', 'kpiRecord', 'kpiType', 'kpiData' ,'kpiRecords', 'useLatestDataAvailable', 'selectedBenchmarkData', 'benchmarkData', 'benchmarkLocation']);
        let filteredKpiData = detailsState.kpiData.filter(kpi => kpi.score);
        let {kpiData} = this.state
        let benchmarkError = false;
        // this.setState({error:false, errorMessage:""})
        // console.log(this.props)

        if (filteredKpiData.length === 0 && (detailsState.selectedBenchmarkData === null || detailsState.selectedBenchmarkData.length === 0)) {
          benchmarkError = true;
         } else {
          if(detailsState.selectedBenchmarkData && detailsState.selectedBenchmarkData.length > 0) {
            let benchmarksWithTrends = detailsState.selectedBenchmarkData[0].filter(benchmark => benchmark.trend.length > 0);
            if (benchmarksWithTrends.length === 0 && filteredKpiData.length === 0 ) {
               benchmarkError = true;
            }
          } 
         }

        if(this.props.kpiError!==true && benchmarkError || (kpiData[0].score ===null || kpiData[0].score ===undefined) ) {
          // this.setState({error: false, errorMessage: ""})
          // console.log("308 - ", this.state, this.props.kpiError, benchmarkError)
          window.scrollTo(0, 0);
          if(this.props.kpiError!==true){
            this.setState({error: true, emptyStateImage: true, errorMessage: "To continue, please select KPIs and/or dates for which there's data available."})
          }
          // this.setState({ error: true, errorMessage: 'Please select start and end dates for a time period which has existing Key Performance Indicators or benchmark data.' });
          return;
        }
        
        if (detailsState.useLatestDataAvailable === false) {
          if (detailsState.endDate === null || detailsState.endDate === ''){
            window.scrollTo(0, 0);
            this.setState({ error: true, errorMessage: 'Please select end date or enable latest data available.' });
            return;
          }
        }

      if (detailsState.startDate && detailsState.startDate !== "" && detailsState.startDate !== null) {
        detailsState.startDate = detailsState.startDate.format('YYYY-MM-DD') + 'T00:00:00.000Z'; 
      } else {
        window.scrollTo(0, 0);
        this.setState({ error: true, errorMessage: 'Please select start date.' });
        return;
      }

      if (detailsState.endDate && detailsState.endDate !== "" && detailsState.endDate!==null) {
        detailsState.endDate = detailsState.endDate.format('YYYY-MM-DD') + 'T23:59:59.000Z';
      } else {
        detailsState.endDate = null;
      }
      
      // if(kpiData[0].score ===null || kpiData[0].score ===undefined){
      //   window.scrollTo(0, 0);
      //   this.setState({ error: true, errorMessage: 'To continue, please select KPIs and/or dates for which there is data available.'});
      //   return
      // }
        // detailsState.kpiRecords[detailsState.kpiRecord.order-1] = detailsState.kpiRecord;
        delete detailsState.kpiRecord;
        this.props.onCompleted({...detailsState});
      };

      //Skip benchmark step
      skipBenchmarkStep = () =>{
        let {kpiData} = {...this.state};
        let scoredKPI = kpiData.filter(kpi => kpi.score);
        // console.log(this.state)
        // return
        if(scoredKPI.length === 0) {
           this.setState({error: true, errorMessage: 'To skip, please select KPIs and/or dates for which there is data available.'});
           window.scrollTo(0, 0);
          } else {
            let details = this.state
            // this.setState({selectedBenchmark:[], benchmarkLocation: {country: null, state: null}})
            // this.setState({})
            details.selectedBenchmarkData =[];
            details.benchmarkLocation = {country: null, state: null}
          this.props.onCompleted({ ...details})
        } 
      }

       // Trigger datepicker on calender icon
    openDatePicker = (id) => {
        document.getElementById(id).click();
    }

    renderCountryOption = (option) => {
      return (option.disabled) ? (<div className="select-gender-disable">{option.name}</div>) : (<div className="gender-option">{option.name}</div>)
    }

    renderErrorMessage = () => {
      return (
        <Row className="mt0">
          <Alert color="info" className="col-lg-11 col-md-11">
            <span className="alert-info-text">
              <span className="alert-info-icon"></span>
              <span>
                <strong>There is currently no benchmark data available for the KPI you selected. </strong><br />
                We are working hard to build anonymized aggregate benchmarks for all KPIs as our users add their data.
                For now, you can select other KPIs to find out if their benchmarks are available.
              </span>
            </span>
          </Alert>
        </Row>
      )
    }


    render() {
        let {kpiList, orgMapping, chartDetails, industriesList, user} = this.props;
        // console.log(this.state)
        let {useLatestDataAvailable, benchmarkValue,selectedBenchmarkData, kpiBenchmarkData,kpiRecord, kpiType, kpiData, benchmarkData, startDate, endDate, benchmarkError, benchmarkLocation, countriesOptions, error, errorMessage} = this.state;
        let {kpiAgreegateData,name,privacy} = chartDetails;
        let alert = null;
        let info = null;
        let kpiSection = null;
        let disableStatesSelect = true;
        let detailsState = pick({...this.state}, ['kpiData', 'useLatestDataAvailable', 'selectedBenchmarkData']);
          console.log(this.state)
        let filteredKpiData = detailsState && detailsState.kpiData && detailsState.kpiData.length >0? detailsState.kpiData.filter(kpi => kpi.score): this.props.goBackToPreviousStep()

       
       

        let statesOptions = []; 
        let {state, country} = benchmarkLocation;
        // console.log(benchmarkLocation)
        benchmarkError = kpiBenchmarkData && kpiBenchmarkData.length === 0;

    

        if((kpiBenchmarkData && kpiBenchmarkData.length > 0 && filteredKpiData && filteredKpiData.length > 0 ) && (!benchmarkData || ( benchmarkData && benchmarkData.score && benchmarkData.score.length === 0))){
          alert = this.renderErrorMessage();
        }
        if (error) {
          if(kpiBenchmarkData.length===0 && filteredKpiData.length!==0){
            alert = this.renderErrorMessage();
          } else {
            alert = <Row><Col sm="11" md="11"><ErrorMessage className="info" message={errorMessage} /></Col></Row>
          }
        }
      if (country && country.code === 'US') {
        statesOptions = getStatesByCountryCode('US');
        statesOptions = statesOptions.map(state => {
          return { id: state.abbreviation, name: state.name }
        });
        statesOptions.splice(0, 0, {id: 'ALL', name: 'All'});
        disableStatesSelect = false;
      }
      countriesOptions = countriesOptions.map(country => {
        if(country.code === 'US') {
          return country;
        } else {
          return {...country, disabled: true}
        }
      })
        if(kpiList) {
        kpiList = kpiList.filter(kpi => {
            if(kpiType==='') {
              return true;
            } else {
              return (kpiType===kpisMapping[kpi.code]['kpiType'])
            }
          })
        }

        if(kpiRecord.occupation!==null){
          disableStatesSelect=true
          state={id: 'ALL', name: 'All'}
        }

        if (false && benchmarkError) {
            info = <Row className="no-kpi-benchmark-available">
                <Col sm="11" md="11">
                  <div className="mt20 mb20">
                    <InfoMessage msg="There is no benchmark data available for the KPI you selected." subMsg="To see the benchmark data, please select a different KPI from the list above." />
                  </div>
                </Col>
              </Row>;
        }
        benchmarkError = false;
        // console.log(disableStatesSelect)
        return <Form>
            {alert}
            {info}
            {kpiSection}
            <div className={this.state.kpiBenchmarkData.length===0?"noBenchmark":""}>
            <FormGroup className={"mb0 ".concat(benchmarkError ? "disabled-benchmark" : "")} row>
              <Col sm={3} className="text-right align-self-center">
                <div className="row d-flex justify-content-end mlmr0">
                  <span id="benchmark-popover" style={{ marginRight: "10px"}} onClick={this.toggleBenchmarkPopover}>
                    <Tooltip />
                  </span>
                  <span className="chartLabel">Benchmark</span>
                  <Popover placement="left" isOpen={this.state.benchmarkPopoverOpen} target="benchmark-popover" toggle={this.toggleBenchmarkPopover}>
                    <PopoverHeader className="popover-header-tooltip">
                      Benchmark
                    </PopoverHeader>
                    <PopoverBody className="popover-body-tooltip">
                      You can see combinations of parameters you can select for benchmarks depending on 
                      the KPI you selected in the previous step, and the currently available benchmark data. 
                      Please note your Enterprise "Industry" designation was set by your Enterprise Admin 
                      when the account was created, and can only be changed by them.
                    </PopoverBody>
                  </Popover>
                </div>
                {/* <div className="focus-instruction d-flex justify-content-end">(Select 1 KPI to benchmark)</div>  */}
              </Col>
            <Col sm={2} md={2}>
              <div className="mapping-select-name">Gender</div>
              <Select name="kpi-select"
                placeholder={"Select..."}
                value={kpiRecord.gender}
                disabled={!kpiRecord.enableGender}
                valueKey="id" labelKey="name"  
                disabled
                />
            </Col>
            <Col sm={2} md={2}>
              <div className="mapping-select-name">Occupation</div>
              <Select name="kpi-select"
                placeholder={"Select..."}
                value={kpiRecord.occupation}
                valueKey="id" labelKey="name"
                disabled
              />
            </Col>
            <Col sm={2} md={2}>
              <div className="mapping-select-name">Job Category</div>
              <Select name="kpi-select"
                placeholder={"Select..."}
                value={kpiRecord.seniority}
                valueKey="id" labelKey="name"
                disabled
              />
            </Col>
            </FormGroup>
            <FormGroup className="mb0 mt25" row>
            <Col sm={{ size: 2, offset: 3 }} md={{ size: 2, offset: 3 }}>
              <div className="mapping-select-name">Country</div>
              <Select
                name="kpi-country-select"
                placeholder={"Select..."}
                value={country}
                onChange={(country) => this.handleCountrySelection(country)}
                options={countriesOptions}
                optionRenderer={this.renderCountryOption}
                valueKey='code'
                labelKey='name'
                disabled={disableStatesSelect}
              />
            </Col>
            <Col sm="2" md="2">
              <div className="mapping-select-name">State</div>
              <Select name="kpi-state-select"
                placeholder={"Select..."}
                value={state}
                onChange={selectedState => this.handleStatesSelection(selectedState)}
                options={statesOptions}
                valueKey="id"
                labelKey="name"
                disabled={disableStatesSelect}
              />
            </Col>
            </FormGroup>
            <FormGroup className={"mb0 mt40 ".concat(benchmarkError ? "disabled-select-date" : "")} row>
              <Col sm={3} md={3} className="text-right">
                <div className="text-right chartLabel">Start Date</div>
              </Col>
              <Col sm={3} md={3} className="align-self-center">
                <div className="inner-addon right-addon">
                  <span className="tool-start-date flaticon-calendar" onClick={() => this.openDatePicker("startDatePicker")} />
                  <DatePicker id="startDatePicker" placeholderText="Select start date" className="input-custom-date form-control" selectsStart showYearDropdown selected={this.state.startDate} onChange={this.handleStartDateChange} startDate={this.state.startDate} endDate={this.state.endDate} maxDate={moment(new Date())} />
                </div>
              </Col>
            </FormGroup>
            <FormGroup className={"mb0 mt25 ".concat(benchmarkError ? "disabled-select-date" : "")} row>
              <Col sm={3} md={3} className="text-right">
                <div className="text-right chartLabel">End Date</div>
              </Col>
              <Col sm={3} md={3} className="align-self-center">
                <div className="inner-addon right-addon">
                  <span className="tool-end-date">
                    <span className="flaticon-calendar" onClick={() => this.openDatePicker("endDatePicker")} />
                  </span>
                  <DatePicker id="endDatePicker" placeholderText="Select end date" className="input-custom-date form-control" selectsEnd showYearDropdown selected={this.state.endDate} onChange={this.handleEndDateChange} startDate={this.state.startDate} endDate={this.state.endDate} disabled={useLatestDataAvailable} minDate={this.state.startDate} maxDate={moment(new Date())} />
                </div>
              </Col>
              <Col className="d-flex pl0">
                <div className="d-flex align-items-center">
                  <span className="or-latest-data">or</span>
                  <span className="ml10">
                    <Toggle defaultChecked={useLatestDataAvailable} icons={false} onChange={this.handleUseLatestDateChange} />
                  </span>
                  <span className="ml10 latest-data-available">
                    latest data available
                  </span>
                  <span id="latest-data-available-popover" className="ml10" onClick={this.toggleLatestDataAvailablePopover}>
                    <Tooltip />
                  </span>
                  <Popover placement="right" isOpen={this.state.dataAvailablePopoverOpen} target="latest-data-available-popover" toggle={this.toggleLatestDataAvailablePopover}>
                    <PopoverHeader className="popover-header-tooltip">
                      Latest Data Available
                    </PopoverHeader>
                    <PopoverBody className="popover-body-tooltip">
                      If you select "latest data available" the time
                      series will include all data from your start date
                      to the latest date that data is available for this
                      KPI. NOTE this chart will be updated automatically
                      when new data is available.
                    </PopoverBody>
                  </Popover>
                </div>
              </Col>
            </FormGroup>
          </div>
          <FormGroup className="mt40 mb20" row>
            <Col sm={{ size: 3 }} md={{ size: 3 }}>
              <Button className="float-left goBackBtn w100" onClick={this.goToPreviousStep}>
                <span className="goBackBtnTxt">
                  <span className="mr10 flaticon-back" /> Go Back
                          </span>
              </Button>
            </Col>
            <Col sm={{ size: 2, offset: 1 }} md={{ size: 2, offset: 1 }}>
              <Button className="float-right goBackBtn w100" onClick={this.skipBenchmarkStep}>
                <span className="cancelBtnTxt">Skip</span>
              </Button>
            </Col>
            <Col sm="2" md="2">
              <Button className={this.state.isPreview?"w100 hidePreviewBtn noBenchmark":"benchmarkPreviewBtn w100"} style={{paddingLeft: '0px', paddingRight: '0px'}} onClick={this.handlePreviewChart}>
                <span className="cancelBtnTxt"><span className="mr10 flaticon-vision" />Preview</span>
              </Button>
            </Col>
            <Col sm={{ size: 3 }} md={{ size: 3 }} className="col-md-offset-right-1">
              <Button className="float-right continueBtn ml10 w100" onClick={this.validateBenchmarkDetails}>
                <span className="continueBtnTxt">
                  Continue <span className="ml10 flaticon-next" />
                </span>
              </Button>
            </Col>
          </FormGroup>
          {this.state.kpiBenchmarkData.length>0?
            <Row className="mt40 mb10">
            <Alert color="info" className="col-lg-11 col-md-11">  
              <span className="alert-info-text">
              <span className="alert-info-icon"></span>
              <b style={{color: "#3b3c41"}}>Your date range might have been expanded in the preview to include a benchmark.</b>
              <br/>If you want to include the benchmark, please expand the date range you previously selected.
              </span>
            </Alert>
            </Row>
          :
          null
          }
            <Row className="mt40 mb20">
            <Col sm={11} md={11}>
                    <ChartPreview
                        name={name}
                        previewOrContinue={this.state.previewOrContinue}
                        privacy={privacy}
                        kpiData={kpiData}
                        benchmarkLocation={this.state.benchmarkLocation}
                        benchmarkData={benchmarkData}
                        startDate={startDate}
                        endDate={endDate}
                        useLatestDataAvailable={useLatestDataAvailable}
                        step={chartStep.benchmark}
                        industriesList={industriesList}
                        user={user}
                        emptyState={this.state.emptyStateImage}
                        {...this.props}
                    />
                    </Col>
                </Row>
          </Form>;
    }
}
